import { useCallback, useContext } from 'react';
import Auth from 'app/utils/Auth';
import { AmplitudeEvent } from 'app/constants/AmplitudeActions';
import { AmplitudeContext, AmplitudeContextInterface } from './AmplitudeProvider';
import { getActiveUserId } from 'app/actions/AuthedActions';
import useWebEngage from 'app/components/WebEngage/useWebEngage';

interface UserProperties {
    [key: string]: string;
}

type UseAmplitudeProps = {
    logEvent?: (event: AmplitudeEvent, eventProperties?: Record<string, any>, userProperties?: UserProperties, callback?: Function) => void;
    setUserProperties?: (props: UserProperties) => any;
    initializeNewUser?: () => any;
};

const useAmplitude = (): UseAmplitudeProps => {
    const { amplitude, userProps } = useContext<AmplitudeContextInterface>(AmplitudeContext);
    const setUserProperties = useCallback((userProperties) => {
        return amplitude.setUserProperties(userProperties);
    }, []);

    const setUserId = useCallback((id) => {
        return amplitude.setUserId(id);
    }, []);

    const { logWebEngage } = useWebEngage();

    const initializeNewUser = useCallback(() => {
        const id = getActiveUserId();
        if (id) {
            const idToken = Auth.getIdToken();
            const entityDetails = Auth.getActiveEntity();
            const { entity_id: entityId = null, group = null, role = null, name: userName = null } = entityDetails || {};
            const userProps = {
                entityId,
                role,
                group,
                userEmail: Auth.getUserEmail(idToken),
                userName,
            };
            setUserId(id || null);
            setUserProperties(userProps);
        }
    }, []);

    const logEvent = useCallback((event, eventProperties, userProperties, callback) => {
        if (userProperties || userProps) {
            console.log(userProps);
        }
        amplitude.logEvent(
            event?.eventName ?? 'INVALID_EVENT',
            {
                category: event?.category ?? '',
                ...eventProperties,
                module: 'bonds',
            },
            callback,
        );
        // Log all the amplitude events to webengage
        logWebEngage(event?.eventName ?? 'INVALID_EVENT', {
            category: event?.category ?? '',
            ...eventProperties,
            module: 'bonds',
        });
    }, []);

    return {
        logEvent,
        setUserProperties,
        initializeNewUser,
    };
};

export default useAmplitude;
